import { createApp } from 'vue';
import App from './App.vue';
import Emitter from 'tiny-emitter';
import store from './store';
import { getServerHost } from './services/util/host';

import router from './routes';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights = null;
const aiConnectionString = process.env.VUE_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;
if (aiConnectionString) {
  appInsights = new ApplicationInsights({ config: { connectionString: aiConnectionString } });
  appInsights.loadAppInsights();
  router.afterEach((to) => {
    appInsights.trackPageView({
      name: to.name ?? to.path,
      uri: to.meta.public ? '/forms/external/[redacted]' : to.fullPath,
    });
  });
}

import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { initialiseEvents } from "./services/events/event-initialiser.js";

import './assets/styles/style.css';
import './assets/styles/tables.css';


const app = createApp(App).use(Quasar, quasarUserOptions).use(router);
app.config.globalProperties.$msalInstance = {};
app.config.globalProperties.$emitter = new Emitter();
app.config.globalProperties.$serverHost = getServerHost();

if (sessionStorage.getItem("authToken") || localStorage.getItem("authToken")) {
    initialiseEvents();
}

app.use(store).mount('#app');
